/// <amd-module name="Comments/Thread/Components/CommentThreadInternalTypes" />
import { IComment } from "Comments/Common/Contracts";
import { IReactionTypeToInfoMap } from "Comments/Reactions/Contracts";

export enum ItemType {
    Comment = 1,
    LoadMore = 2,
    Add = 3
}

export interface IUICommentListItem {
    type: ItemType;

    /** the last error which occurred on this item */
    lastError?: string;
}

export interface IUICommentLoadMore extends IUICommentListItem {
    /** The comment id of the parent comment, if any (undefined if it's a root comment) */
    parentId?: number;
}

export interface IUICommentAdd extends IUICommentListItem {
    /** The comment id of the parent comment, if any (undefined if it's a root comment) */
    parentId?: number;
}

/**
 * UI wrapper for a comment which contains properties for the comment's UI state.
 */
export interface IUIComment extends IUICommentListItem {
    /** reference to the comment object */
    comment: IComment;

    /** map of reactions of each type */
    reactionTypeToInfoMap?: IReactionTypeToInfoMap;

    /** Are we currently editing this comment? */
    isEditing?: boolean;

    /** Is this comment read-only? */
    readonly?: boolean;
}
